import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const CopilotPage = lazy(() => import('./pages/CopilotPage'));
const PredictiveModelsPage = lazy(() => import('./pages/PredictiveModelsPage'));
const AutoClassificationPage = lazy(() => import('./pages/AutoClassificationPage'));
const DocumentIntelligencePage = lazy(() => import('./pages/DocumentIntelligencePage'));
const AnomalyDetectionPage = lazy(() => import('./pages/AnomalyDetectionPage'));
const WritingAssistantPage = lazy(() => import('./pages/WritingAssistantPage'));
const NaturalLanguageSearchPage = lazy(() => import('./pages/NaturalLanguageSearchPage'));

export const AiRoutes: RouteObject = {
  path: 'ai',
  element: <ModuleGuard moduleId="data.ai" />,
  handle: { crumb: 'AI & Intelligence' },
  children: [
    { index: true, element: <Navigate to="copilot" replace /> },
    { path: 'copilot', element: <CopilotPage />, handle: { crumb: 'Copilot' } },
    { path: 'predictive-models', element: <PredictiveModelsPage />, handle: { crumb: 'Predictive Models' } },
    { path: 'auto-classification', element: <AutoClassificationPage />, handle: { crumb: 'Auto Classification' } },
    { path: 'document-intelligence', element: <DocumentIntelligencePage />, handle: { crumb: 'Document Intelligence' } },
    { path: 'anomaly-detection', element: <AnomalyDetectionPage />, handle: { crumb: 'Anomaly Detection' } },
    { path: 'writing-assistant', element: <WritingAssistantPage />, handle: { crumb: 'Writing Assistant' } },
    { path: 'natural-language-search', element: <NaturalLanguageSearchPage />, handle: { crumb: 'Natural Language Search' } },
  ],
};
